import type { ReactNode } from 'react';
import { Modal } from './Modal.js';

export type RemoveScope = 'note' | 'client' | 'all';

/**
 * ehr#571 (PROGRESS_NOTE_10-20-V141 V131) / ehr#682: the Remove question with its three scopes:
 * This note only, This client going forward, and All clients going forward (red, far right). The
 * same buttons and classes as the Quick add section's Remove (pn-rm-modal).
 */
export function RemoveScopeModal({
  title,
  children,
  onPick,
  onClose,
}: {
  title: string;
  children: ReactNode;
  onPick: (scope: RemoveScope) => void;
  onClose: () => void;
}) {
  const pick = (s: RemoveScope) => () => {
    onPick(s);
    onClose();
  };
  return (
    <Modal
      title={title}
      onClose={onClose}
      className="pn-rm-modal"
      actions={
        <>
          <button type="button" className="btn" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn" onClick={pick('note')}>
            This note only
          </button>
          <button type="button" className="btn" onClick={pick('client')}>
            This client going forward
          </button>
          <button type="button" className="btn danger" onClick={pick('all')}>
            All clients going forward
          </button>
        </>
      }
    >
      <p className="pn-modal-p">{children}</p>
    </Modal>
  );
}
